import React from 'react';

import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

interface EditorialHeroProps {
  title: string;
  subtitle?: string;
  lead?: string;
  /** Une phrase détachée sous le chapô, quand la page en met une en avant. */
  highlight?: string;
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: '0.75rem',
    maxWidth: '38rem',
    margin: '0 auto',
  },
  // Le surtitre est un paragraphe, pas un titre : le `h1` reste le premier et le seul titre de
  // niveau 1 de la page, et l'ordre de lecture suit l'ordre visuel.
  subtitle: {
    fontSize: '0.8rem',
    fontWeight: 600,
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    color: theme.palette.client.primary.main,
  },
  title: {
    fontFamily: 'Bitter, serif',
    fontWeight: 700,
    fontSize: 'clamp(2rem, 6vw, 3rem)',
    lineHeight: 1.1,
    color: theme.palette.client.primary.extraDark,
  },
  lead: {
    fontSize: '1.1rem',
    lineHeight: 1.6,
    color: '#4a4a4a',
  },
  highlight: {
    marginTop: '0.25rem',
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: 1.55,
    color: theme.palette.client.primary.dark,
  },
}));

const EditorialHero: React.FC<EditorialHeroProps> = ({ title, subtitle, lead, highlight }) => {
  const classes = useStyles();

  return (
    <header className={classes.root}>
      {subtitle && <Typography className={classes.subtitle}>{subtitle}</Typography>}
      <Typography variant="h1" className={classes.title}>
        {title}
      </Typography>
      {lead && <Typography className={classes.lead}>{lead}</Typography>}
      {highlight && <Typography className={classes.highlight}>{highlight}</Typography>}
    </header>
  );
};

export default EditorialHero;
